import { useAuth } from "@/contexts/AuthContext";
import { Prohibit, SignOut } from "@phosphor-icons/react";

/**
 * Shown when a logged-in user has been suspended by an admin. Their token is
 * still valid (so /auth/me works) but every other API call returns 403. We
 * block the UI entirely and only expose a Sign out action.
 */
export default function SuspendedScreen() {
  const { user, logout } = useAuth();
  return (
    <div className="suspended-screen" data-testid="suspended-screen">
      <div className="suspended-card">
        <div className="suspended-icon">
          <Prohibit size={36} weight="duotone" />
        </div>
        <p className="label-uppercase suspended-eyebrow">Access paused</p>
        <h1 className="suspended-title">Your account has been suspended.</h1>
        <p className="suspended-sub">
          An administrator has temporarily revoked access to the Consultation
          Hub for <strong>{user?.email}</strong>. If you believe this is a
          mistake, please reach out directly.
        </p>
        <button
          onClick={logout}
          className="btn btn-accent suspended-cta"
          data-testid="suspended-logout"
        >
          <SignOut size={16} weight="bold" />
          Sign out
        </button>
      </div>
    </div>
  );
}
